import React from "react";

const BalancedSwapIcon = ({
  width = 52,
  height = 52,
  primaryColor = "#FFC01D",
  secondaryColor = "#C7B300",
  strokeColor = "white",
}) => {
  // Calculate the viewBox aspect ratio to maintain proportions
  const aspectRatio = 52; // original width/height is square
  const viewBoxWidth = aspectRatio;
  const viewBoxHeight = aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id="filter0_f_6139_13165"
          x="-0.998047"
          y="-1"
          width="54"
          height="54"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6"
            result="effect1_foregroundBlur_6139_13165"
          />
        </filter>
        <filter
          id="filter1_i_6139_13165"
          x="11.0078"
          y="11.0117"
          width="30.0117"
          height="31.5074"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.5" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_6139_13165"
          />
        </filter>
        <filter
          id="filter2_d_6139_13165"
          x="15.1703"
          y="18.4701"
          width="21.6604"
          height="18.06"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.5" />
          <feGaussianBlur stdDeviation="1.95" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6139_13165"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6139_13165"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6139_13165"
          x1="12.001"
          y1="14"
          x2="36.001"
          y2="35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primaryColor} />
          <stop offset="1" stopColor={secondaryColor} />
        </linearGradient>
      </defs>
      <g filter="url(#filter0_f_6139_13165)">
        <path
          d="M21.4766 26L24.4891 29.025L30.5266 22.975"
          stroke={primaryColor}
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.4391 14.0624C25.3016 13.3249 26.7141 13.3249 27.5891 14.0624L29.5641 15.7624C29.9391 16.0874 30.6391 16.3499 31.1391 16.3499H33.2641C34.5891 16.3499 35.6766 17.4374 35.6766 18.7624V20.8874C35.6766 21.3749 35.9391 22.0874 36.2641 22.4624L37.9641 24.4374C38.7016 25.2999 38.7016 26.7124 37.9641 27.5874L36.2641 29.5624C35.9391 29.9374 35.6766 30.6374 35.6766 31.1374V33.2624C35.6766 34.5874 34.5891 35.6749 33.2641 35.6749H31.1391C30.6516 35.6749 29.9391 35.9374 29.5641 36.2624L27.5891 37.9624C26.7266 38.6999 25.3141 38.6999 24.4391 37.9624L22.4641 36.2624C22.0891 35.9374 21.3891 35.6749 20.8891 35.6749H18.7266C17.4016 35.6749 16.3141 34.5874 16.3141 33.2624V31.1249C16.3141 30.6374 16.0516 29.9374 15.7391 29.5624L14.0516 27.5749C13.3266 26.7124 13.3266 25.3124 14.0516 24.4499L15.7391 22.4624C16.0516 22.0874 16.3141 21.3874 16.3141 20.8999V18.7499C16.3141 17.4249 17.4016 16.3374 18.7266 16.3374H20.8891C21.3766 16.3374 22.0891 16.0749 22.4641 15.7499L24.4391 14.0624Z"
          stroke={primaryColor}
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter1_i_6139_13165)">
        <path
          d="M24.1253 11.6755C25.1603 10.7905 26.8553 10.7905 27.9053 11.6755L30.2753 13.7155C30.7253 14.1055 31.5653 14.4205 32.1653 14.4205H34.7153C36.3053 14.4205 37.6103 15.7255 37.6103 17.3155V19.8655C37.6103 20.4505 37.9253 21.3055 38.3153 21.7555L40.3553 24.1255C41.2403 25.1605 41.2403 26.8555 40.3553 27.9055L38.3153 30.2755C37.9253 30.7255 37.6103 31.5655 37.6103 32.1655V34.7155C37.6103 36.3055 36.3053 37.6105 34.7153 37.6105H32.1653C31.5803 37.6105 30.7253 37.9255 30.2753 38.3155L27.9053 40.3555C26.8703 41.2405 25.1753 41.2405 24.1253 40.3555L21.7553 38.3155C21.3053 37.9255 20.4653 37.6105 19.8653 37.6105H17.2703C15.6803 37.6105 14.3753 36.3055 14.3753 34.7155V32.1505C14.3753 31.5655 14.0603 30.7255 13.6853 30.2755L11.6603 27.8905C10.7903 26.8555 10.7903 25.1755 11.6603 24.1405L13.6853 21.7555C14.0603 21.3055 14.3753 20.4655 14.3753 19.8805V17.3005C14.3753 15.7105 15.6803 14.4055 17.2703 14.4055H19.8653C20.4503 14.4055 21.3053 14.0905 21.7553 13.7005L24.1253 11.6755Z"
          fill="url(#paint0_linear_6139_13165)"
        />
      </g>
      <path
        d="M24.4664 12.0746L24.4665 12.0745C25.303 11.3592 26.7089 11.3555 27.565 12.0752C27.5656 12.0758 27.5663 12.0763 27.567 12.0769L29.9315 14.1122C29.9317 14.1124 29.932 14.1126 29.9322 14.1129C30.218 14.3603 30.6004 14.5641 30.9803 14.706C31.3605 14.8481 31.7844 14.9455 32.1653 14.9455H34.7153C36.0154 14.9455 37.0853 16.0154 37.0853 17.3155V19.8655C37.0853 20.2395 37.1831 20.6635 37.3244 21.044C37.4657 21.4242 37.6693 21.8114 37.9179 22.0986C37.9181 22.0988 37.9184 22.0991 37.9186 22.0993L39.9563 24.4667C39.9564 24.4668 39.9566 24.467 39.9568 24.4672C40.6716 25.3038 40.6751 26.7092 39.9555 27.5652C39.955 27.5658 39.9544 27.5665 39.9539 27.5671L37.9186 29.9316C37.9184 29.9319 37.9181 29.9321 37.9179 29.9324C37.6704 30.2182 37.4667 30.6006 37.3248 30.9805C37.1827 31.3607 37.0853 31.7846 37.0853 32.1655V34.7155C37.0853 36.0155 36.0154 37.0855 34.7153 37.0855H32.1653C31.7912 37.0855 31.3673 37.1832 30.9868 37.3246C30.6066 37.4659 30.2194 37.6695 29.9322 37.9181C29.932 37.9183 29.9317 37.9185 29.9315 37.9187L27.5641 39.9564C27.5639 39.9567 27.5636 39.9569 27.5633 39.9571C26.7267 40.6717 25.3214 40.6752 24.4656 39.9557C24.465 39.9551 24.4643 39.9546 24.4637 39.954L22.0991 37.9187C22.0989 37.9185 22.0987 37.9183 22.0984 37.9181C21.8126 37.6706 21.4302 37.4668 21.0503 37.3249C20.6701 37.1829 20.2462 37.0855 19.8653 37.0855H17.2703C15.9703 37.0855 14.9003 36.0155 14.9003 34.7155V32.1505C14.9003 31.776 14.8024 31.3559 14.6633 30.9801C14.5239 30.6036 14.3254 30.2235 14.0886 29.9394L14.0886 29.9394L14.0855 29.9357L12.0622 27.5527C12.0619 27.5523 12.0617 27.552 12.0614 27.5517C11.3566 26.7122 11.3566 25.3187 12.0614 24.4792C12.0617 24.4789 12.0619 24.4786 12.0622 24.4783L14.0855 22.0953L14.0855 22.0953L14.0886 22.0916C14.3254 21.8075 14.5239 21.4274 14.6633 21.0508C14.8024 20.675 14.9003 20.2549 14.9003 19.8805V17.3005C14.9003 16.0004 15.9703 14.9305 17.2703 14.9305H19.8653C20.2394 14.9305 20.6633 14.8327 21.0438 14.6913C21.4237 14.5502 21.8106 14.3468 22.0977 14.0985C22.0982 14.0981 22.0987 14.0976 22.0991 14.0972L24.4664 12.0746Z"
        stroke={strokeColor}
        strokeOpacity="0.4"
        strokeWidth="1.05"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#filter2_d_6139_13165)">
        <path
          d="M20.5703 26.0001L24.1853 29.6301L31.4303 22.3701"
          stroke={strokeColor}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};

export default BalancedSwapIcon;
